import { useDispatch } from "react-redux";
import { setFilters } from "../redux/reducer/filterslice";
import { cloneDeep } from "lodash";

const useInitialFilter = () => {
    const dispatch = useDispatch();

    const setInitialFilter = (filters) => {
        let _filters = cloneDeep(filters);
        delete _filters.isEnabled;
        delete _filters.isArchived;
        dispatch(setFilters(_filters));
    };

    return setInitialFilter;
};

export default useInitialFilter;